import { FactorModule } from './../routes/factor/factor.module';
import { LoadformComponent } from "./views/dashboard/components/loadform/loadform.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ModuleWithProviders } from "@angular/core";

// Import Containers
import { DefaultLayoutComponent } from "./containers";

import { P404Component } from "./views/error/404.component";
import { P500Component } from "./views/error/500.component";
import { LoginComponent } from "./views/login/login.component";
import { RegisterComponent } from "./views/register/register.component";
// import { LoadstatusComponent } from "./views/loadstatus/loadstatus.component";
import { CompanyregisterComponent } from "./views/companyregister/companyregister.component";
import { EmailValidateComponent } from "./views/email-validate/email-validate.component";
import { ForgotpasswordComponent } from "./views/forgotpassword/forgotpassword.component";
import { ValidateupdatepasswordComponent } from "./views/validateupdatepassword/validateupdatepassword.component";
import { CompanyregistrationComponent } from "./views/companyregistration/companyregistration.component";
import { UnauthorizedComponent } from "./views/error/unauthorized/unauthorized.component";
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoadManagementComponent } from '../routes/load/load-management/load-management.component';
import { CompanyJoinRequestComponent } from './views/company-join-request/company-join-request.component';
import { RoleGuard } from './views/role.guard';
import {TruckTrackerComponent} from './views/truck-tracker/truck-tracker.component';
export const routes: Routes = [
  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },

  {
    path: "404",
    component: P404Component,
    data: {
      title: "Page 404",
    },
  },
  {
    path: "500",
    component: P500Component,
    data: {
      title: "Page 500",
    },
  },
  {
    path: "login",
    // redirectTo: "/dashboard/loadstatus",
    // pathMatch: "full",
    component: LoginComponent,
    data: {
      title: "Login Page",
    },
  },
  {
    path: "login/:token",
    component: LoginComponent,
    data: {
      title: "Login Page",
    },
  },
  {
    path: "register",
    component: RegisterComponent,
    data: {
      title: "Register Page",
    },
  },
  {
    path: "forgotPassword",
    component: ForgotpasswordComponent,
    data: {
      title: "Forgotpassword Page",
    },
  },
  {
    path: "forgotpassword/:token",
    component: ValidateupdatepasswordComponent,
    data: {
      title: "Validatepassword Page",
    },
  },
  {
    path: "joincompanyrequest/:token",
    canActivate: [RoleGuard],
    component: CompanyJoinRequestComponent,
    data: {
      title: "Company Join Request Page",
      allowedRoles: [3]
    },
  },
  {
    path: "companyregister",
    component: CompanyregistrationComponent,
    data: {
      title: "Company Register Page",
    },
  },
  {
    path: "validate/:token",
    component: EmailValidateComponent,
    data: {
      title: "Email Validate",
    },
  },

  {
    path: 'setup',
    redirectTo: "setup/trucks-list",
    pathMatch: "full",
  },
  {
    path: 'expense',
    redirectTo: "expense/vendors-list",
    pathMatch: "full",
  },
  {
    path: 'profitability-utilization',
    redirectTo: "profitability-utilization/load-profitability",
    pathMatch: "full",
  },
  {
    path: "load",
    // redirectTo: localStorage.getItem("subscriptionType") != 'basic' ? "load/ratecon-uploads" : "load/createload" ,
    component: LoadManagementComponent,
    pathMatch: "full",
  },
  {
    path: "sales",
    redirectTo: "sales/invoice",
    pathMatch: "full",
  },
  {
    path: "factor",
    redirectTo: "factor/factor-list",
    pathMatch: "full",
  },
  {
    path: "loadpay",
    redirectTo: "loadpay/driver-pay",
    pathMatch: "full",
  },
  {
    path: "fuel",
    redirectTo: "fuel/fuelcard-list",
    pathMatch: "full",
  },
  {
    path: "job",
    redirectTo: "job/joblist",
    pathMatch: "full",
  },
  {
    path: "dispatch",
    redirectTo: "dispatch/jobschedules",
    pathMatch: "full",
  },
  {
    path: "tracking",
    redirectTo: "tracking/tracking",
    pathMatch: "full",
  },
  {
    path: "delivery",
    redirectTo: "delivery/jobloads",
    pathMatch: "full",
  },
  {
    path: "jobsales",
    redirectTo: "jobsales/jobsales-list",
    pathMatch: "full",
  },
  {
    path: "compliance",
    redirectTo: "compliance/inspection",
    pathMatch: "full",
  },
  {
    path: "companysettings",
    redirectTo: "companysettings/edit-company",
    pathMatch: "full",
  },
  {
    path: "theme",
    redirectTo: "theme/users",
    pathMatch: "full",
  },
  { path: "unauthorized", component: UnauthorizedComponent },
  // {
  //   path: "",
  //   component: DefaultLayoutComponent,
  //   data: {
  //     title: "Home",
  //   },
  //   children: [
  //     {
  //       path: "base",
  //       loadChildren: () =>
  //         import("./views/base/base.module").then((m) => m.BaseModule),
  //     },

  //     {
  //       path: "dashboard",
  //       loadChildren: () =>
  //         import("./views/dashboard/dashboard.module").then(
  //           (m) => m.DashboardModule
  //         ),
  //     },

  //     {
  //       path: "theme",
  //       loadChildren: () =>
  //         import("./views/theme/theme.module").then((m) => m.ThemeModule),
  //     },
  //     {
  //       path: "e-banking",
  //       loadChildren: () =>
  //         import("./views/e-banking/e-banking.module").then((m) => m.EBankingModule),
  //     },
  //     {
  //       path: "workorder",
  //       loadChildren: () =>
  //         import("./views/workorder/workorder.module").then((m) => m.WorkorderModule),
  //     },
  //     {
  //       path: "fuel",
  //       loadChildren: () =>
  //         import("./views/fuel/fuel.module").then((m) => m.FuelModule),
  //     },
  //     {
  //       path: "profitability-utilization",
  //       loadChildren: () =>
  //         import("./views/profitability-utilization/profitability-utilization.module").then((m) => m.ProfitabilityUtilizationModule),
  //     },
  //     {
  //       path: "fiancedatasync",
  //       loadChildren: () =>
  //         import("./views/fiancedatasync/fiancedatasync.module").then((m) => m.FiancedatasyncModule),
  //     },
  //   ],


  // },


  // {
  //   path: "base",
  //   component: DefaultLayoutComponent,
  //   loadChildren: () =>
  //     import("./views/base/base.module").then((m) => m.BaseModule),
  // },

  {
    path: "resetpassword",
    component: DefaultLayoutComponent,
    data: {
      title: "Home",
    },
    children: [
      {
        path: "",
        component: ResetPasswordComponent,
        data: {
          title: "Reset Password Page",
        }
      }
    ]
  },
  {
    path: "dashboard",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: "job-dashboard",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/job-dashboard/job-dashboard.module").then(
        (m) => m.JobDashboardModule
      ),
  },

  {
    path: "theme",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/theme/theme.module").then((m) => m.ThemeModule),
  },
  {
    path: "setup",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("../routes/setup-routes/setup/setup.module").then((m) => m.SetupModule),
  },
  {
    path: "load",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("../routes/load/load.module").then((m) => m.LoadModule),
  },
  {
    path: "sales",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("../routes/sales/sales.module").then((m) => m.SalesModule),
  },
  {
    path: "factor",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("../routes/factor/factor.module").then((m) => m.FactorModule),
  },
  {
    path: "loadpay",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("../routes/loadpay/loadpay.module").then((m) => m.LoadpayModule),
  },
  {
    path: "expense",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("../routes/expense/expense.module").then((m) => m.ExpenseModule),
  },
  {
    path: "e-banking",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/e-banking/e-banking.module").then((m) => m.EBankingModule),
  },
  {
    path: "workorder",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/workorder/workorder.module").then((m) => m.WorkorderModule),
  },
  {
    path: "job",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/job/job.module").then((m) => m.JobModule),
  },
  {
    path: "delivery",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("../routes/delivery/delivery.module").then((m) => m.DeliveryModule),
  },
  {
    path: "jobsales",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/jobsales/jobsales.module").then((m) => m.JobsalesModule),
  },
  {
    path: "fuel",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/fuel/fuel.module").then((m) => m.FuelModule),
  },
  {
    path: "profitability-utilization",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/profitability-utilization/profitability-utilization.module").then((m) => m.ProfitabilityUtilizationModule),
  },
  {
    path: "fiancedatasync",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/fiancedatasync/fiancedatasync.module").then((m) => m.FiancedatasyncModule),
  },
  {
    path: "compliance",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/compliance/compliance.module").then((m) => m.ComplianceModule),
  },
  {
    path: "configuration",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/configuration/configuration.module").then((m) => m.ConfigurationModule),
  },
  {
    path: "dispatch",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/dispatch-management/dispatch-management.module").then((m) => m.DispatchManagementModule),
  },
  {
    path: "tracking",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/tracking/tracking.module").then((m) => m.TrackingModule),
    
  },
  {
    path: "companysettings",
    component: DefaultLayoutComponent,
    loadChildren: () =>
      import("./views/company-settings/company-settings.module").then((m) => m.CompanySettingsModule),
  },
  {
    path: 'truck/live-tracking',
    component: TruckTrackerComponent,
  },

  { path: "**", component: P404Component },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
// export const AppRoutingModule: ModuleWithProviders =
//   RouterModule.forRoot(routes);
